import Countdown from 'react-count-down'
import ReactDOM from 'react-dom'
import React from 'react'

class CountDownTimer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      endDate: props.endDate,
      expired: props.expired || false
    }
  }

  expire() {
    this.setState({expired: true})
  }

  countDownOptions() {
    let cb = () => {
      console.info('Timer Expired.')
      this.expire()
    }

    return {
      endDate: this.state.endDate,
      prefix: "left",
      cb
    }
  }

  render() {
    if(this.state.expired == true) {
      return(
        <div className="react-count-down">
          <span>Time Expired</span>
        </div>
      )
    } else {
      return(
        <Countdown options={this.countDownOptions()} />
      )
    }
  }
}

export default CountDownTimer;
